import { AppConfig } from '@isocel/front-common';

import { Permission } from '../queries/api/types';

const appConfig: AppConfig<Permission> = {
    PAGE_SIZE: 50,
    API: {
        BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api',
        KEY: process.env.REACT_APP_API_KEY || '',
    },
    SEO: {
        BASE_URL: '',
        SITE_NAME: 'Emballage',
        DEFAULT_TITLE: 'Emballage',
        DEFAULT_DESCRIPTION: 'Emballage',
    },
    PRODUCT_NAME: 'Emballage',
    GOOGLE_ANALYTICS: process.env.REACT_APP_GOOGLE_ANALYTICS || '',
    ENABLE_DEBUG_LOGS: false, // process.env.NODE_ENV === 'production',
    DEBUG_LOGS_APP: '', // <app>_<service>
    VERSION: process.env.REACT_APP_VERSION || '',
    FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || '',
    MENU_POLLING_INTERVAL_IN_MS: 15000,
    NOTIFICATIONS_REFETCH_INTERVAL_IN_MS: 5000,
    APPOINTMENT_NOTIFICATIONS_REFETCH_INTERVAL_IN_MS: 30000,
};

export default Object.freeze(appConfig);
